<section class="service-cell">
  @if (params.data.isTrialEntitlement) {
    <span
      raUiBadge="TRIAL"
      [badgeConfig]="{
        position: BadgePosition.After,
        color: BADGE_STATUS_COLORS.Information,
        size: BadgeSize.Small,
      }"
    >
      @if (params) {
        <div class="body-2-bold ellipsis">
          @if (checkIsNew()) {
            <span
              class="inline-display"
              raUiBadge="."
              [badgeConfig]="{
                position: BadgePosition.Before,
                color: BADGE_STATUS_COLORS.Information,
                size: BadgeSize.Indicator,
              }"
            ></span>
          }
          <span [ngClass]="greyOutText ? 'grey-out' : ''">{{ params.data?.detailServiceDataHeaders?.header }}</span>
        </div>
      }
    </span>
  } @else {
    @if (params) {
      <div class="body-2-bold ellipsis">
        @if (checkIsNew()) {
          <span
            class="inline-display"
            raUiBadge="."
            [badgeConfig]="{
              position: BadgePosition.Before,
              color: BADGE_STATUS_COLORS.Information,
              size: BadgeSize.Indicator,
            }"
          ></span>
        }
        <span [ngClass]="greyOutText ? 'grey-out' : ''">{{ params.data?.detailServiceDataHeaders?.header }}</span>
      </div>
    }
  }

  <div class="body-2 ellipsis" [ngStyle]="{ 'padding-bottom': toggle ? '10px' : '' }">
    @if (toggle && params) {
      <div>Product Family: {{ params.data.productFamily }}</div>
      <div>Catalog ID: {{ params.data.catalogNumber }}</div>
      <div>Entitlement Type: {{ params.data.entitlementType }}</div>
      <div>
        @if (params.isUserEntitlement) {
          Assigned To: {{ params.data.primaryEmail }}
        } @else {
          Allocated By: {{ params.data.ownerEmail }}
        }
      </div>
      <span class="toggle" (click)="toggleDetails()"
        >Entitlement Details <i class="ra-icon-ide-sm-chevron-up align-middle"></i>
      </span>
    } @else {
      <ng-container *ngTemplateOutlet="toggleElements"></ng-container>
    }
    <ng-template #toggleElements>
      <span class="toggle" (click)="toggleDetails()"
        >Entitlement Details <i class="ra-icon-ide-sm-chevron-down align-middle"></i>
      </span>
    </ng-template>
  </div>
</section>
